<template>
<div>
   <h-header title="审核" :back="true" @loginSuccess="loginSuccess"></h-header>
   <div class="change-btn">
       <div class="btn hover" 
       v-if="legalizeObj.type==0 || status==0" 
       :class="{'active':legalizeObj.type == 0 && status==0}" 
       @click="legalizeObj.type=0">
        个人
       </div>
       <div class="btn hover"  
       :class="{'active':legalizeObj.type == 1 && status==0}" 
       v-if="legalizeObj.type==1 || status==0" 
       @click="legalizeObj.type=1">
       企业
       </div>
   </div>
   <div class="create-class-box" v-if="status == 0">
        <Row>
            <Col span="5">
                <span class="tit">{{showTit[legalizeObj.type].name}}</span>
            </Col>
            <Col span="8">
                <Input v-model="legalizeObj.name" :placeholder="showNote[legalizeObj.type].name" style="width:100%"/>
            </Col>
        </Row>
        <Row>
            <Col span="5">
                <span class="tit">{{showTit[legalizeObj.type].mobile}}</span>
            </Col>
            <Col span="8">
                <Input v-model="legalizeObj.mobile" type="number" :placeholder="showNote[legalizeObj.type].mobile" style="width:100%"></Input>
            </Col>
        </Row>
        <Row>
            <Col span="5">
                <span class="tit">{{showTit[legalizeObj.type].idNum}}</span>
            </Col>
            <Col span="8">
                <Input v-model="legalizeObj.idNum" type="number" :placeholder="showNote[legalizeObj.type].idNum"  style="width:100%"></Input>
            </Col>
        </Row>
        <Row>
            <Col span="5">
                <span class="tit">{{showTit[legalizeObj.type].certificate}}</span>
            </Col>
            <Col span="8">
                <Upload class="img-box input"
                action=""
                :before-upload="handleUpload"
                >
                    <Button class="img-button">
                        <div v-if="!legalizeObj.certificate">
                            <img v-if="legalizeObj.type==0" src="../assets/images/audit_up.png">
                            <img v-else src="../assets/images/audit_bus.png">
                        </div>
                        <div v-else>
                            <img :src="splitUrl(legalizeObj.certificate)">
                        </div>
                    </Button>
                </Upload>
            </Col>
        </Row>
        <Row>
            <Col span="5">
                <span class="tit">{{showTit[legalizeObj.type].reason}}</span>
            </Col>
            <Col span="8">
                <Input v-model="legalizeObj.reason" type="textarea" :placeholder="showNote[legalizeObj.type].reason" />
            </Col>
        </Row>
        <div class="create-btn hover" @click="applyLegalize">保存</div>
    </div>
   <div class="audit-ing" v-else>
       <div class="show-img">
           <img src="../assets/images/auditing.png">
       </div>
       <div class="p1">您的真实身份资料已经提交</div>
       <div class="p2" v-if="status==1">正在审核中...</div>
       <div class="p2" v-if="status==2">认证成功</div>
       <div class="p2" v-if="status==3">认证失败</div>
       <div class="right-btn hover" v-if="status==3" @click="status=0">重新提交</div>
   </div>
   <h-footer></h-footer>
</div>
</template>
<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
export default {
    name:'Audit',
    data(){
        return{
            status:0,
            legalizeObj:{
                type:0,//0/个人1/组织
                certificate:'',//证书
                idNum:'',//个人：身份症号，企业：组织代码
                mobile:'',//手机号
                name:'',
                reason:'',//0/未申请认证 1/申请认证2/认证成功 3/认证失败
            },
            showTit:[{
                name:'姓名',
                mobile:'手机号码',
                idNum:'身份证号',
                certificate:'身份证照片',
                reason:'创建原因'
            },{
                name:'组织名称',
                mobile:'联系方式',
                idNum:'组织代码',
                certificate:'营业执照',
                reason:'创建原因'
            }],
            showNote:[{
                name:'请填写姓名',
                mobile:'请填写手机号码',
                idNum:'请填写身份证号',
                certificate:'身份证照片',
                reason:'请填写内容'
            },{
                name:'请填写名称',
                mobile:'请填写联系方式',
                idNum:'请填写组织代码',
                certificate:'身份证照片',
                reason:'请填写内容'
            }]
        }
    },
    components:{
        'h-header':Header,
        'h-footer':Footer
    },
    activated(){
        
    },
    methods:{
        loginSuccess(){
            this.getLegalize()
        },
        handleUpload(file,node,insert){
            let that = this
            this.$post(this,{
                'url':'getOssToken',
                'data':{
                    'uploadDir':'classroom/audit'
                },
                'success':function(reData){
                    var reData = JSON.parse(reData.token)
                    that.$postImage(that,file,reData,{
                        'success':function(data){
                            that.legalizeObj.certificate = data
                        }
                    })
                }
            })
            return false
        },
        getLegalize(){
            let that = this
            this.$post(this,{
                url:'getLegalize',
                success(data){
                    that.legalizeObj = data
                    that.status = data.status
                    if(that.status == 2){
                        that.openWindow('AdminRoom')
                    }
                }
            })
        },
        applyLegalize(){
            let that = this
            this.$post(this,{
                url:'applyLegalize',
                data:that.legalizeObj,
                success(data){
                    that.toast('提交成功，请等待审核')
                    that.status = 1
                }
            })
        }
    },
    computed:{
        
    }
}
</script>
<style scoped>
.change-btn{
    display: flex;
    padding:20px;
    border-bottom: 1px solid #CDCDCD;
    width:1200px;
    margin:0 auto;
}
.change-btn .btn{
    width:70px;
    height:40px;
    line-height: 40px;
    background:#999999;
    border-radius:5px;
    margin-right: 20px;
    color: #fff;
    font-size: 18px;
}
.change-btn .btn.active{
    background:rgba(133,168,203,1);
}
.create-class-box{
    width:1200px;
    margin:20px auto 0 auto;
    font-size: 18px;
    padding:27px 58px 30px;
    margin:0 auto;
}
.create-class-box .title{
    font-size: 20px;
    margin-bottom: 20px;
    color: #fff;
}
.create-class-box .tit{
    color: #fff;
}
.create-class-box .ivu-row{
    margin-bottom: 20px;
}

.create-class-box .btn{
    width:259px;
    height:40px;
    line-height: 40px;
    background:rgba(105,195,125,1);
    border-radius:20px;
    text-align: center;
    margin:0 auto;
    color: #fff;
}
.create-class-box .img-box{
    text-align: left;
}
.create-class-box >>> .ivu-upload-select{
    position: relative;
    width:202px;
    height:133px;
    border-radius:3px;
}
.create-class-box >>> .ivu-btn{
    background: transparent;
    border:none;
}
.create-class-box .ivu-upload-select img{
    position:absolute;
    width:100%;
    height: 100%;
    top: 0;
    left: 0;
}
.create-class-box .img-button{
    width:100%;
    height: 100%;
}
.create-class-box .img-button .ivu-icon-md-add{
    font-size: 40px;
}
.create-class-box .create-btn{
    width:200px;
    height:40px;
    line-height: 40px;
    color: #fff;
    background:rgba(105,195,125,1);
    border-radius:20px;
    margin:0 auto;
}

.audit-ing{
    width:1200px;
    margin:0 auto;
    padding-bottom:40px;
}
.audit-ing .show-img{
    margin-top: 77px;
}
.audit-ing .p1{
    font-size: 30px;
    color:#D9D9D9;
    margin-top: 36px;
}
.audit-ing .p2{
    font-size: 24px;
    margin-top: 25px;
    color: #fff;
}
.audit-ing .right-btn{
    width:100px;
    height:30px;
    line-height: 30px;
    color:#fff;
    font-size: 17px;
    background:rgba(105,195,125,1);
    border-radius:15px;
    float: right;
}
</style>